// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import {
//   Box,
//   Button,
//   Typography,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   IconButton,
//   Autocomplete,
//   TextField,
// } from "@mui/material";
// import { QrReader } from "react-qr-reader";
// import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
// import { format } from "date-fns";

// import HeaderBannerPage from "../components/HeaderBannerPage";
// import { fetchEmployeeDetails } from "../actions/EmpDeatilsAction";
// import { fetchJobs } from "../actions/AssignAction";
// import { QrJobAction } from "../actions/QrJobAction";
// import { FiTrash2 } from "react-icons/fi";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";


// const QRJobScanner = () => {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { employeeId, department, role } = location.state || {};

//   const { employeeDetails, loading } = useSelector(
//   (state) => state.employeeDetails || {}
// );

//   const { jobValue = [] } = useSelector(
//     (state) => state.assignJob || {}
//   );

//   const [ServiceNo, setServiceNo] = useState("");
//   const [action, setAction] = useState("");
//   const [scanning, setScanning] = useState(false);
//   const [selectedJob, setSelectedJob] = useState(null);
//   const [selectedJobIwNo, setSelectedJobIwNo] = useState("");
//   const [scannedEmployees, setScannedEmployees] = useState([]);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [showDetail, setShowDetail] = useState(false);

//   const getTodayDate = () => new Date().toISOString().split("T")[0];
//   const getScanDateTime = () => format(new Date(), "yyyy-MM-dd HH:mm:ss");
  

//   useEffect(() => {
//     if (!employeeId || !department) return;

//     const date = getTodayDate();
//     dispatch(fetchJobs(date, employeeId));
//   }, [dispatch, employeeId, department, role]);

//   const getEmployeeByServiceNo = async (value) => {
//   const clean = value.toString().trim();

//   try {
//     const res = await dispatch(fetchEmployeeDetails(clean));
//     return res || null;
//   } catch {
//     return null;
//   }
// };

//   const handleActionClick = (type) => {
//     setAction(type);
//     setServiceNo("");
//     setSelectedJob(null);
//     setSelectedJobIwNo("");
//     setScannedEmployees([]);
//     setScanning(type === "JobOut");
//   };

//   const handleBackClick = () => {
//     setAction("");
//     setScanning(false);
//     setSelectedJob(null);
//     setSelectedJobIwNo("");
//     setScannedEmployees([]);
//   };


//   const handleJobChange = (event, newValue) => {
//     setSelectedJob(newValue);
//     if (newValue) {
//       const job = jobValue.find((j) => j.jobDescription === newValue.jobDescription);
//       setSelectedJobIwNo(job?.iwNo || "");
//       setScanning(true);
//     } else {
//       setSelectedJobIwNo("");
//       setScanning(false);
//     }
//   };

//   useEffect(() => {
//   if (!ServiceNo) return;

//   const fetchEmployee = async () => {
//     const employee = await getEmployeeByServiceNo(ServiceNo);

//     if (!employee) {
//       setSnackbarMessage(`Employee ${ServiceNo} not found`);
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//       setServiceNo("");
//       return;
//     }

//     const item = {
//       id: employee.id ,
//       serviceNo: employee.ServiceNo,
//       EmpName: employee.ReportName,
//       jobScanTime: getScanDateTime(),
//       iwNo: action === "JobIn" ? selectedJobIwNo : 0,
//     };

//     setScannedEmployees((prev) => {
//       const alreadyScanned = prev.some(
//         (emp) => emp.serviceNo === item.serviceNo
//       );

//       if (alreadyScanned) {
//         setSnackbarMessage(`Employee ${item.serviceNo} already scanned`);
//         setSnackbarSeverity("warning");
//         setSnackbarOpen(true);
//         return prev;
//       }

//       return [...prev, item];
//     });

//     setServiceNo("");
//   };

//   fetchEmployee();
// }, [ServiceNo]);

//   const handleSubmitScanned = () => {
//   if (!scannedEmployees.length) return;

//   const attendJobList = scannedEmployees.map((emp) => ({
//     serviceNo: emp.serviceNo,
//     jobScanTime: emp.jobScanTime,
//     iwNo: action === "JobIn" ? emp.iwNo : 0,
//     id: emp.id,
//   }));

//   const payload = {
//     action: action,
//     supervisor: employeeId,
//     atttendJobList: JSON.stringify(attendJobList),
//   };

//   dispatch(QrJobAction(payload));

//   // reset state
//   setAction("");
//   setScanning(false);
//   setSelectedJob(null);
//   setSelectedJobIwNo("");
//   setScannedEmployees([]);

//   setSnackbarMessage(`${action} submitted successfully!`);
//   setSnackbarSeverity("success");
//   setSnackbarOpen(true);
// };

// const handleRemoveScanned = (ServiceNo) => {
//   setScannedEmployees((prev) =>
//     prev.filter((emp) => emp.serviceNo !== ServiceNo)
//   );

//   const employee = scannedEmployees.find(
//     (emp) => emp.serviceNo === ServiceNo
//   );

//   setSnackbarMessage(`Removed ${employee?.EmpName || ServiceNo}`);
//   setSnackbarSeverity("info");
//   setSnackbarOpen(true);
// };



//   return (
//     <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
//       <HeaderBannerPage />
//       {action && (
//         <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
//           <IconButton
//             onClick={handleBackClick}
//             sx={{
//               backgroundColor: "#154C79",
//               color: "#fff",
//               marginRight: "12px",
//               "&:hover": { backgroundColor: "#0e3c66" },
//             }}
//           >
//             <ArrowBackIcon />
//           </IconButton>

//           <Typography sx={{ fontWeight: "bold", color: "#142C54" }}>
//             {action === "JobIn" ? "Job In" : "Job Out"}
//           </Typography>
//         </Box>
//       )}
//       {/* Action Buttons */}
//       {!action && (
//         <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4, flexWrap: 'wrap' }}>
//           <Button
//             variant="contained"
//             onClick={() => handleActionClick("JobIn")}
//             sx={{
//               backgroundColor: "#142C54",
//               color: "#fff",
//               fontSize: "1rem",
//               borderRadius: "10px",
//               padding: "10px 20px",
//               "&:hover": { backgroundColor: "#0E3C59" },
//             }}
//           >
//             <FiArrowDownLeft style={{ marginRight: 8 }} />
//             Job In
//           </Button>
//           <Button
//             variant="contained"
//             color="error"
//             onClick={() => handleActionClick("JobOut")}
//             sx={{
//               fontSize: "1rem",
//               borderRadius: "10px",
//               padding: "10px 20px",
//             }}
//           >
//             <FiArrowUpRight style={{ marginRight: 8 }} />
//             Job Out
//           </Button>
//         </Box>
//       )}

//       {/* Job Dropdown for JobIn - Now Searchable and Mobile-Friendly */}
//       {action === "JobIn" && !scanning && (
//         <Box sx={{ maxWidth: 400, mx: "auto", mt: 4, px: 2 }}>
//           <Autocomplete
//             value={selectedJob}
//             onChange={handleJobChange}
//             options={jobValue}
//             getOptionLabel={(option) => option.jobDescription || ""}
//             isOptionEqualToValue={(option, value) => 
//               option.jobDescription === value?.jobDescription
//             }
//             renderInput={(params) => (
//               <TextField
//                 {...params}
//                 label="Search Job"
//                 placeholder="Type to search..."
//                 sx={{
//                   backgroundColor: "#F0F4F8",
//                   borderRadius: "20px",
//                   "& .MuiOutlinedInput-root": {
//                     borderRadius: "20px",
//                     "& fieldset": {
//                       borderColor: "#154C79",
//                     },
//                     "&:hover fieldset": {
//                       borderColor: "#154C79",
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: "#154C79",
//                     },
//                   },
//                   "& .MuiInputLabel-root": {
//                     color: "#154C79",
//                   },
//                   "& .MuiInputLabel-root.Mui-focused": {
//                     color: "#154C79",
//                   },
//                 }}
//               />
//             )}
//             sx={{
//               "& .MuiAutocomplete-paper": {
//                 borderRadius: "10px",
//               },
//             }}
//             ListboxProps={{
//               sx: {
//                 maxHeight: "250px",
//                 "& .MuiAutocomplete-option": {
//                   padding: "12px 16px",
//                   borderBottom: "1px solid #e0e0e0",
//                   "&:last-child": {
//                     borderBottom: "none",
//                   },
//                   "&[aria-selected='true']": {
//                     backgroundColor: "#E3F2FD !important",
//                   },
//                   "&.Mui-focused": {
//                     backgroundColor: "#F0F4F8 !important",
//                   },
//                 },
//               },
//             }}
//             noOptionsText="No jobs found"
//             clearOnBlur
//             selectOnFocus
//           />
//         </Box>
//       )}

//       {/* QR Scanner */}
//       {scanning && (
//         <Box sx={{ maxWidth: 400, mx: "auto", mt: 4, p: 2, boxShadow: "0px 4px 8px rgba(0,0,0,0.1)", borderRadius: "10px", backgroundColor: "#fff" }}>
//           <Typography align="center" sx={{ fontWeight: "bold", mb: 2 }}>
//             {action} QR Scan
//           </Typography>

//           <QrReader
//             constraints={{ facingMode: "environment" }}
//             onResult={(result) => {
//               if (result?.text) setServiceNo(result.text.trim());
//             }}
//             style={{ width: "100%", borderRadius: "10px" }}
//           />

//           <Box
//           sx={{
//             mt: 2,
//             maxHeight: "250px", 
//             overflowY: "auto",
//             pr: 1,
//             "&::-webkit-scrollbar": {
//               width: "6px",
//             },
//             "&::-webkit-scrollbar-thumb": {
//               backgroundColor: "#154C79",
//               borderRadius: "10px",
//             },
//           }}
//         >
//           {scannedEmployees.map((e) => {
//             const employee = e;
//               return (
//                 <Box
//                   key={e.id}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     mb: 1,
//                     p: 2,
//                     borderRadius: "10px",
//                     boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
//                     backgroundColor: "#F0F4F8",
//                   }}
//                 >
//                 <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
//                   <Box>
//                     <Typography sx={{ fontWeight: "bold", color: "#142C54" }}>
//                       {employee?.EmpName || "N/A"}
//                     </Typography>
//                     <Typography sx={{ fontSize: "0.85rem", color: "#154C79" }}>
//                       Service No: {e.serviceNo}
//                     </Typography>
//                   </Box>

//                   <Button
//                     color="error"
//                     onClick={() => handleRemoveScanned(e.serviceNo)}
//                     sx={{ minWidth: "40px" }}
//                   >
//                     <FiTrash2 />
//                   </Button>
//                 </Box>
//                 </Box>
//               );
//             })}
//           </Box>


//           {scannedEmployees.length > 0 && (
//             <Button
//               sx={{
//                 mt: 3,
//                 width: "100%",
//                 backgroundColor: "#142C54",
//                 color: "#fff",
//                 borderRadius: "10px",
//                 padding: "10px",
//                 "&:hover": { backgroundColor: "#0E3C59" },
//               }}
//               onClick={handleSubmitScanned}
//             >
//               Submit
//             </Button>
//           )}
//         </Box>
//       )}

//       {/* Loading */}
//       {loading && (
//         <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
//           <CircularProgress />
//         </Box>
//       )}

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default QRJobScanner;



import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Snackbar,
  Alert,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import { QrReader } from "react-qr-reader";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import { format } from "date-fns";

import HeaderBannerPage from "../components/HeaderBannerPage";
import { fetchEmployeeDetails } from "../actions/EmpDeatilsAction";
import { fetchJobs } from "../actions/AssignAction";
import { QrJobAction } from "../actions/QrJobAction";
import IwoStatusManage from "./IwoStatusManage";
import { FiTrash2, FiClipboard } from "react-icons/fi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const QRJobScanner = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { employeeId, department, role } = location.state || {};

  const { employeeDetails, loading } = useSelector(
  (state) => state.employeeDetails || {}
);

  const { jobValue = [] } = useSelector(
    (state) => state.assignJob || {}
  );

  const [ServiceNo, setServiceNo] = useState("");
  const [action, setAction] = useState("");
  const [scanning, setScanning] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedJobIwNo, setSelectedJobIwNo] = useState("");
  const [scannedEmployees, setScannedEmployees] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showDetail, setShowDetail] = useState(false);

  const getTodayDate = () => new Date().toISOString().split("T")[0];
  const getScanDateTime = () => format(new Date(), "yyyy-MM-dd HH:mm:ss");
  

  useEffect(() => {
    if (!employeeId || !department) return;

    const date = getTodayDate();
    dispatch(fetchJobs(date, employeeId));
  }, [dispatch, employeeId, department, role]);

  const getEmployeeByServiceNo = async (value) => {
  const clean = value.toString().trim();

  try {
    const res = await dispatch(fetchEmployeeDetails(clean));
    return res || null;
  } catch {
    return null;
  }
};

  const handleActionClick = (type) => {
    setAction(type);
    setServiceNo("");
    setSelectedJob(null);
    setSelectedJobIwNo("");
    setScannedEmployees([]);
    setScanning(type === "JobOut");
  };

  const handleBackClick = () => {
    setAction("");
    setScanning(false);
    setSelectedJob(null);
    setSelectedJobIwNo("");
    setScannedEmployees([]);
  };

  // IWO States Manage — open the IWO list of the logged employee
  const handleIwoStatusClick = () => {
    const loggedServiceNo = employeeId || localStorage.getItem("employeeId");

    if (!loggedServiceNo) {
      setSnackbarMessage("Logged employee service no not found");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    setAction("IwoStatus");
    setScanning(false);
    setSelectedJob(null);
    setSelectedJobIwNo("");
    setScannedEmployees([]);
  };


  const handleJobChange = (event, newValue) => {
    setSelectedJob(newValue);
    if (newValue) {
      const job = jobValue.find((j) => j.jobDescription === newValue.jobDescription);
      setSelectedJobIwNo(job?.iwNo || "");
      setScanning(true);
    } else {
      setSelectedJobIwNo("");
      setScanning(false);
    }
  };

  useEffect(() => {
  if (!ServiceNo) return;

  const fetchEmployee = async () => {
    const employee = await getEmployeeByServiceNo(ServiceNo);

    if (!employee) {
      setSnackbarMessage(`Employee ${ServiceNo} not found`);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      setServiceNo("");
      return;
    }

    const item = {
      id: employee.id ,
      serviceNo: employee.ServiceNo,
      EmpName: employee.ReportName,
      jobScanTime: getScanDateTime(),
      iwNo: action === "JobIn" ? selectedJobIwNo : 0,
    };

    setScannedEmployees((prev) => {
      const alreadyScanned = prev.some(
        (emp) => emp.serviceNo === item.serviceNo
      );

      if (alreadyScanned) {
        setSnackbarMessage(`Employee ${item.serviceNo} already scanned`);
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
        return prev;
      }

      return [...prev, item];
    });

    setServiceNo("");
  };

  fetchEmployee();
}, [ServiceNo]);

  const handleSubmitScanned = () => {
  if (!scannedEmployees.length) return;

  const attendJobList = scannedEmployees.map((emp) => ({
    serviceNo: emp.serviceNo,
    jobScanTime: emp.jobScanTime,
    iwNo: action === "JobIn" ? emp.iwNo : 0,
    id: emp.id,
  }));

  const payload = {
    action: action,
    supervisor: employeeId,
    atttendJobList: JSON.stringify(attendJobList),
  };

  dispatch(QrJobAction(payload));

  // reset state
  setAction("");
  setScanning(false);
  setSelectedJob(null);
  setSelectedJobIwNo("");
  setScannedEmployees([]);

  setSnackbarMessage(`${action} submitted successfully!`);
  setSnackbarSeverity("success");
  setSnackbarOpen(true);
};

const handleRemoveScanned = (ServiceNo) => {
  setScannedEmployees((prev) =>
    prev.filter((emp) => emp.serviceNo !== ServiceNo)
  );

  const employee = scannedEmployees.find(
    (emp) => emp.serviceNo === ServiceNo
  );

  setSnackbarMessage(`Removed ${employee?.EmpName || ServiceNo}`);
  setSnackbarSeverity("info");
  setSnackbarOpen(true);
};



  return (
    <Box sx={{ padding: 0, maxWidth: "95%", margin: "0 auto" }}>
      <HeaderBannerPage />
      {action && (
        <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
          <IconButton
            onClick={handleBackClick}
            sx={{
              backgroundColor: "#154C79",
              color: "#fff",
              marginRight: "12px",
              "&:hover": { backgroundColor: "#0e3c66" },
            }}
          >
            <ArrowBackIcon />
          </IconButton>

          <Typography sx={{ fontWeight: "bold", color: "#142C54" }}>
            {action === "JobIn"
              ? "Job In"
              : action === "IwoStatus"
              ? "IWO States Manage"
              : "Job Out"}
          </Typography>
        </Box>
      )}
      {/* Action Buttons */}
      {!action && (
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mt: 4, flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            onClick={() => handleActionClick("JobIn")}
            sx={{
              backgroundColor: "#142C54",
              color: "#fff",
              fontSize: "1rem",
              borderRadius: "10px",
              padding: "10px 20px",
              "&:hover": { backgroundColor: "#0E3C59" },
            }}
          >
            <FiArrowDownLeft style={{ marginRight: 8 }} />
            Job In
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => handleActionClick("JobOut")}
            sx={{
              fontSize: "1rem",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
          >
            <FiArrowUpRight style={{ marginRight: 8 }} />
            Job Out
          </Button>

          {/* IWO States Manage */}
          {/* <Button
            variant="contained"
            onClick={handleIwoStatusClick}
            sx={{
              width: "100%",
              maxWidth: "320px",
              mt: 1,
              backgroundColor: "#154C79",
              color: "#fff",
              fontSize: "1rem",
              borderRadius: "10px",
              padding: "10px 20px",
              "&:hover": { backgroundColor: "#0E3C59" },
            }}
          >
            <FiClipboard style={{ marginRight: 8 }} />
            IWO States Manage
          </Button> */}
        </Box>
      )}

      {/* IWO States Manage — separate display component */}
      {action === "IwoStatus" && (
        <IwoStatusManage
          serviceNo={employeeId || localStorage.getItem("employeeId")}
        />
      )}

      {/* Job Dropdown for JobIn - Now Searchable and Mobile-Friendly */}
      {action === "JobIn" && !scanning && (
        <Box sx={{ maxWidth: 400, mx: "auto", mt: 4, px: 2 }}>
          <Autocomplete
            value={selectedJob}
            onChange={handleJobChange}
            options={jobValue}
            getOptionLabel={(option) => option.jobDescription || ""}
            isOptionEqualToValue={(option, value) => 
              option.jobDescription === value?.jobDescription
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Job"
                placeholder="Type to search..."
                sx={{
                  backgroundColor: "#F0F4F8",
                  borderRadius: "20px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "20px",
                    "& fieldset": {
                      borderColor: "#154C79",
                    },
                    "&:hover fieldset": {
                      borderColor: "#154C79",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "#154C79",
                    },
                  },
                  "& .MuiInputLabel-root": {
                    color: "#154C79",
                  },
                  "& .MuiInputLabel-root.Mui-focused": {
                    color: "#154C79",
                  },
                }}
              />
            )}
            sx={{
              "& .MuiAutocomplete-paper": {
                borderRadius: "10px",
              },
            }}
            ListboxProps={{
              sx: {
                maxHeight: "250px",
                "& .MuiAutocomplete-option": {
                  padding: "12px 16px",
                  borderBottom: "1px solid #e0e0e0",
                  "&:last-child": {
                    borderBottom: "none",
                  },
                  "&[aria-selected='true']": {
                    backgroundColor: "#E3F2FD !important",
                  },
                  "&.Mui-focused": {
                    backgroundColor: "#F0F4F8 !important",
                  },
                },
              },
            }}
            noOptionsText="No jobs found"
            clearOnBlur
            selectOnFocus
          />
        </Box>
      )}

      {/* QR Scanner */}
      {scanning && (
        <Box sx={{ maxWidth: 400, mx: "auto", mt: 4, p: 2, boxShadow: "0px 4px 8px rgba(0,0,0,0.1)", borderRadius: "10px", backgroundColor: "#fff" }}>
          <Typography align="center" sx={{ fontWeight: "bold", mb: 2 }}>
            {action} QR Scan
          </Typography>

          <QrReader
            constraints={{ facingMode: "environment" }}
            onResult={(result) => {
              if (result?.text) setServiceNo(result.text.trim());
            }}
            style={{ width: "100%", borderRadius: "10px" }}
          />

          <Box
          sx={{
            mt: 2,
            maxHeight: "250px", 
            overflowY: "auto",
            pr: 1,
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#154C79",
              borderRadius: "10px",
            },
          }}
        >
          {scannedEmployees.map((e) => {
            const employee = e;
              return (
                <Box
                  key={e.id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                    p: 2,
                    borderRadius: "10px",
                    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                    backgroundColor: "#F0F4F8",
                  }}
                >
                <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                  <Box>
                    <Typography sx={{ fontWeight: "bold", color: "#142C54" }}>
                      {employee?.EmpName || "N/A"}
                    </Typography>
                    <Typography sx={{ fontSize: "0.85rem", color: "#154C79" }}>
                      Service No: {e.serviceNo}
                    </Typography>
                  </Box>

                  <Button
                    color="error"
                    onClick={() => handleRemoveScanned(e.serviceNo)}
                    sx={{ minWidth: "40px" }}
                  >
                    <FiTrash2 />
                  </Button>
                </Box>
                </Box>
              );
            })}
          </Box>


          {scannedEmployees.length > 0 && (
            <Button
              sx={{
                mt: 3,
                width: "100%",
                backgroundColor: "#142C54",
                color: "#fff",
                borderRadius: "10px",
                padding: "10px",
                "&:hover": { backgroundColor: "#0E3C59" },
              }}
              onClick={handleSubmitScanned}
            >
              Submit
            </Button>
          )}
        </Box>
      )}

      {/* Loading */}
      {loading && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <CircularProgress />
        </Box>
      )}

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default QRJobScanner;